var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M11.037 19.791l-5.69-5.6-1.937 1.896 7.627 7.5L27.41 7.483 25.486 5.59z","transform":"translate(-3.41 -5.59)"}));
}

IconCheck.defaultProps = {"width":"24","height":"18","viewBox":"0 0 24 18"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
